export const createAutoCompleteComponentModel = (definition) => {
    return { definition };
};
//# sourceMappingURL=createAutoCompleteComponentModel.js.map